import React, { type FC } from 'react'

const SiteRelatedInformation: FC = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 9C0.5 4.02944 4.52944 0 9.5 0H31.5C36.4706 0 40.5 4.02944 40.5 9V31C40.5 35.9706 36.4706 40 31.5 40H9.5C4.52944 40 0.5 35.9706 0.5 31V9Z"
      fill="#FF5887"
    />
    <g clipPath="url(#clip0_2944_31798)">
      <path
        d="M31.4998 19C31.3663 18.992 31.2327 19.0123 31.1078 19.0598C30.9828 19.1072 30.8693 19.1806 30.7748 19.2751C30.6803 19.3696 30.6069 19.4831 30.5595 19.608C30.5121 19.733 30.4917 19.8666 30.4998 20V22H10.4997V15C10.5078 14.8666 10.4874 14.733 10.44 14.608C10.3926 14.4831 10.3192 14.3696 10.2247 14.2751C10.1302 14.1806 10.0167 14.1072 9.89172 14.0598C9.76676 14.0123 9.63316 13.992 9.49975 14C9.36634 13.992 9.23274 14.0123 9.10778 14.0598C8.98282 14.1072 8.86934 14.1806 8.77483 14.2751C8.68032 14.3696 8.60694 14.4831 8.55952 14.608C8.5121 14.733 8.49173 14.8666 8.49975 15V31C8.49173 31.1334 8.5121 31.267 8.55952 31.392C8.60694 31.5169 8.68032 31.6304 8.77483 31.7249C8.86934 31.8194 8.98282 31.8928 9.10778 31.9402C9.23274 31.9876 9.36634 32.008 9.49975 32C9.63316 32.008 9.76676 31.9876 9.89172 31.9402C10.0167 31.8928 10.1302 31.8194 10.2247 31.7249C10.3192 31.6304 10.3926 31.5169 10.44 31.392C10.4874 31.267 10.5078 31.1334 10.4997 31V28H30.4998V31C30.4998 31.2652 30.6051 31.5196 30.7926 31.7071C30.9802 31.8946 31.2345 32 31.4998 32C31.765 32 32.0193 31.8946 32.2069 31.7071C32.3944 31.5196 32.4998 31.2652 32.4998 31V20C32.5078 19.8666 32.4874 19.733 32.44 19.608C32.3926 19.4831 32.3192 19.3696 32.2247 19.2751C32.1302 19.1806 32.0167 19.1072 31.8917 19.0598C31.7668 19.0123 31.6332 18.992 31.4998 19Z"
        fill="white"
      />
      <path
        d="M12.5 16H14.5C15.2956 16 16.0587 16.3161 16.6213 16.8787C17.1839 17.4413 17.5 18.2044 17.5 19V20H12.5V16Z"
        fill="white"
      />
      <path
        d="M27.5 12H23.5V8H21.5V12H17.5V14H21.5V18H23.5V14H27.5V12Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2944_31798">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(8.5 8)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SiteRelatedInformation
